import { FC } from 'react';
import { Typography } from '../../../../../components/style';
import { dateDifference } from '../../../../../services/utils';
import { theme } from '../../../../../styles/theme';

type LastUpdatedProps = {
  lastUpdated: Date;
  lastUpdatedText: string;
};

const LastUpdated: FC<LastUpdatedProps> = ({ lastUpdated, lastUpdatedText }) => {
  const { days } = dateDifference(lastUpdated);

  return (
    <Typography size={theme.typography.fontSize} data-testid='last-updated'>
      {isNaN(days) ? '' : days + lastUpdatedText}
    </Typography>
  );
};

export default LastUpdated;
